import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";

// Children optional in case we need HTML in label
const CheckboxField = ({
	registeredName,
	label,
	isRequired,
	requiredText,
	children,
	onChange,
	wrapperClass,
}: {
	registeredName: string;
	label: string;
	isRequired: boolean;
	requiredText?: string;
	children?: React.ReactNode;
	onChange?: (event: any) => void;
	wrapperClass?: string;
}) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const wrapperClasses = `flex relative ${wrapperClass}`;

	return (
		<div className="mb-3">
			{errors && (
				<p className="text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}
			<div className={wrapperClasses}>
				<div className="relative flex">
					<input
						type="checkbox"
						id={`input-${registeredName}`}
						{...register(registeredName)}
						className="checked:border-1 disabled:border-steel-400 disabled:bg-steel-400 peer relative mt-1 h-4 w-4 shrink-0 appearance-none border border-black bg-white checked:bg-black focus:outline-none focus:ring-1 focus:ring-blue-100 focus:ring-offset-0"
						onChange={onChange}
						required={isRequired}
					/>
					<svg
						className="pointer-events-none absolute inset-0 mt-1 hidden h-4 w-4 stroke-white outline-none peer-checked:block"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="4"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<polyline points="20 6 9 17 4 12"></polyline>
					</svg>
				</div>
				<label className="ml-2 text-sm" htmlFor={`input-${registeredName}`}>
					{children ? children : label}
					{isRequired && "*"}
				</label>
			</div>
		</div>
	);
};
export default CheckboxField;
